export enum NotificationItemContentType {
    DatabaseItemValue = 'DatabaseItemValue',
    Message = 'Message',
}
